import { TrackingEvent } from '@marketplace-web/shared/event-tracker-data'

type TaxpayersFormForceTriggerEventArgs = {
  screen: string
}

type TaxpayersFormForceTriggerEventExtra = {
  screen: string
}

export const taxpayersFormForceTriggerEvent = (args: TaxpayersFormForceTriggerEventArgs) => {
  const extra: TaxpayersFormForceTriggerEventExtra = {
    screen: args.screen,
  }

  return {
    event: 'taxpayers.form_force_trigger',
    extra,
  }
}

type TaxpayersInputEventArgs = {
  screen: string
  target: string
  value?: string
  state: 'focus' | 'unfocus'
}

export const taxpayersInputEvent = (args: TaxpayersInputEventArgs): TrackingEvent => {
  const { screen, target, value, state } = args

  return {
    event: 'taxpayers.input',
    extra: { screen, target, value, state },
  }
}

type TaxpayersViewScreenEventArgs = {
  screen: string
  details: string | null
}

export const taxpayersViewScreenEvent = (args: TaxpayersViewScreenEventArgs): TrackingEvent => {
  const { screen, details } = args

  return {
    event: 'taxpayers.view_screen',
    extra: { screen, details },
  }
}

type TaxpayerTimeOnTaskEventArgs = {
  screen: string
  duration: number
}

type TaxpayerTimeOnTaskEventExtra = {
  screen: string
  duration: number
}

export const taxpayerTimeOnTaskEvent = (args: TaxpayerTimeOnTaskEventArgs) => {
  const extra: TaxpayerTimeOnTaskEventExtra = {
    screen: args.screen,
    duration: args.duration,
  }

  return {
    event: 'taxpayers.time_in_dac7_flow',
    extra,
  }
}
